export default "__VITE_ASSET__C7HKoW3v__"